import { css } from '@emotion/css';
import sendBackToPCIcon from '@volumental/assets/icons/SendDataBackToPC.svg';
import { Container, Content, Text } from '@volumental/common';
import { type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Header } from '../../../components/accessible-components';
import { type ScanResult } from '../../../types/types';
import { QrCode } from './qr-code';

const QrContainer = css`
  width: 100%;
  text-align: center;
  position: relative;
  display: flex;
  flex-direction: column;
  height: auto;
  min-height: 300px;
  background-color: #eff6fa;
`;

const headerContainer = css`
  position: absolute;
  top: 0px;
  width: 100%;
`;

const imageStyle = css`
  aspect-ratio: 1;
  max-height: 100%;
  object-fit: contain;
  border-radius: 1rem;
  align-self: center;
  max-width: 160px;
  padding-top: 32px;
`;

const contentStyle = css`
  padding: 0px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const QrStyle = css`
  max-height: 100%;
  border-radius: 1rem;
  align-self: center;
  margin-top: 70px;
  margin-bottom: 30px;
`;

interface QrCodeViewProps {
  onBack?: () => void;
  onClose: () => void;
  onScan: (scanResult: ScanResult) => void;
}
export function QrCodeView({
  onBack,
  onClose,
  onScan,
}: QrCodeViewProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <Container>
      <Content disableGutters disableScrollbar>
        <div className={QrContainer}>
          <div className={QrStyle}>
            <QrCode onScan={onScan} />
          </div>
          <div className={headerContainer}>
            <Header back={onBack} close={onClose} />
          </div>
        </div>
        <div className={contentStyle}>
          <div style={{ textAlign: 'center', paddingTop: '32px' }}>
            <Text style={{ fontSize: '32px' }}>{t('scanQR')}</Text>
          </div>
          <div style={{ textAlign: 'center', paddingTop: '16px' }}>
            <Text>{t('scanTheQRCodeToFindYourBestSize')}</Text>
          </div>
          <img
            src={sendBackToPCIcon}
            alt={t('imageAlt.qrWaiting')}
            className={imageStyle}
          />
          <div
            style={{
              textAlign: 'center',
              paddingTop: '16px',
              paddingBottom: '16px',
            }}
          >
            <Text>{t('waitingForMeasurement')}</Text>
          </div>
        </div>
      </Content>
    </Container>
  );
}
